import { Card, Col, Row } from "antd";
import { useCallback, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setDynoHistoryData,
  setDynoStartDetails,
  setDynoTestRunningStatus,
  setDynoStopDetails,
} from "../../../../../../reducers/eolTestsSlice";
import { getApis } from "../../../../../Common/apis";
import { vehicleTestListUrl } from "../../../../../Common/endpoints";
import DynoTests from "./DynoTests";
import ModeGrafana from "./ModeGrafana";
import VehicleDetails from "../../../../VehicleDetails";
import { EOL_TESTS } from "../../../../../Common/Grafana/Constants";
import GetIframe from "../../../../../Common/Grafana/GetIframe";
import { getGrafanaBaseURL } from "../../../../../Common/Utils";
import { setNavStop } from "../../../../../../reducers/authSlice";

const History = ({ onChangeImei, vehicle, rearTyreDiameter }) => {
  const dispatch = useDispatch();
  const eol = useSelector((state) => state.eolTests);
  const vehicleSlice = useSelector((state) => state.eol);
  const vehicleDetails = vehicleSlice?.vehicleDetails;
  const response = eol?.dynoResult;
  const dynoHistoryData = eol?.dynoHistoryData;
  const authToken = localStorage.getItem("authToken");
  const paginationDetails = eol?.dynoPaginationDetails;

  const baseFilterObject = useMemo(() => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));

    return {
      orgId: userDetails?.currentOrganisation?.grafanaOrganisationId,
      vehicle_id: vehicleDetails?.vehId,
      rear_wheel_diameter: rearTyreDiameter,
      from: response?.startTime,
      to: response?.stopTime,
    };
  }, [
    vehicleDetails?.vehId,
    rearTyreDiameter,
    response?.startTime,
    response?.stopTime,
  ]);

  const getDynoHistoryData = useCallback(async () => {
    await getApis(
      vehicleTestListUrl,
      {
        vIdVal: vehicleDetails?.vehId,
        type: "DYNO",
        page: paginationDetails.current - 1,
        size: paginationDetails.pageSize,
      },
      authToken
    )
      .then((res) => {
        if (res?.data?.content?.[0]?.status !== "RUNNING") {
          dispatch(
            setDynoHistoryData({
              list: res?.data?.content,
              total: res?.data?.totalElements,
            })
          );
        } else {
          dispatch(setDynoStartDetails(res?.data?.content?.[0]));
          dispatch(setDynoTestRunningStatus(true));
          dispatch(setNavStop(true));
          dispatch(setDynoStopDetails({}));
        }
      })
      .catch((e) => {
        console.log(e);
        dispatch(setNavStop(false));
      });
  }, [authToken, dispatch, vehicleDetails.vehId, paginationDetails]);

  useEffect(() => {
    if (vehicleDetails?.vehId) {
      getDynoHistoryData();
    }
  }, [getDynoHistoryData, vehicleDetails.vehId]);

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={24} md={24} lg={5} xl={5}>
          <VehicleDetails
            onChangeImei={onChangeImei}
            imei={vehicle}
            cardHeight={"100%"}
          />
        </Col>
        <Col xs={24} sm={24} md={24} lg={19} xl={19}>
          <Card
            className="h100"
            title="Dyno Tests History"
            styles={{ body: { padding: "4px", minHeight: "243px" } }}
          >
            <DynoTests />
          </Card>
        </Col>
      </Row>
      {vehicleDetails?.id &&
      response?.startTime &&
      dynoHistoryData?.length > 0 ? (
        <>
          <Row gutter={[16, 8]} className="mt1">
            <Col xs={24} sm={24} md={24} lg={12} xl={12} id="dyno-current">
              <GetIframe
                title="EOL Current"
                url={getGrafanaBaseURL(
                  EOL_TESTS.DYNO.DASHBOARD_ID,
                  EOL_TESTS.DYNO.DASHBOARD_NAME
                )}
                panelId={EOL_TESTS.DYNO.PANEL_ID["current"]}
                variableObject={baseFilterObject}
                variableKeys={EOL_TESTS.DYNO.BASE_VARIABLES}
                width="100%"
                height="220"
                divId="dyno-current"
              />
            </Col>

            <Col xs={24} sm={24} md={24} lg={12} xl={12} id="dyno-speed">
              <GetIframe
                title="EOL Speed"
                url={getGrafanaBaseURL(
                  EOL_TESTS.DYNO.DASHBOARD_ID,
                  EOL_TESTS.DYNO.DASHBOARD_NAME
                )}
                panelId={EOL_TESTS.DYNO.PANEL_ID["speed"]}
                variableObject={baseFilterObject}
                variableKeys={EOL_TESTS.DYNO.BASE_VARIABLES}
                width="100%"
                height="220"
                divId="dyno-speed"
              />
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={24}>
              {vehicleDetails?.driveModeSpeed?.map((item, index) => (
                <ModeGrafana
                  item={item}
                  key={index}
                  rearTyreDiameter={rearTyreDiameter}
                />
              ))}
            </Col>
          </Row>
        </>
      ) : null}
    </>
  );
};
export default History;
